import { type ClaimFilterDto, getClaims } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

const getClaimsListQueryKey = (filter: ClaimFilterDto) => [
	"CLAIM_LIST",
	filter.marketId,
	filter.verticals,
];

export function useClaimsList(filter: ClaimFilterDto) {
	return useQuery({
		queryKey: getClaimsListQueryKey(filter),
		queryFn: processResponse(() =>
			getClaims(filter.marketId, filter.verticals),
		),
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
